import { FileInfoDTO } from './FileInfoDTO'
import { ReviewedDocumentation } from '@/Domain/ReviewedDocumentation'

export class ReviewedDocumentationDTO {
  private _procedureCode: string
  private _procedureInternalId: number
  private _madeiristaId: number
  private _batchInternalId: number
  private _documents: FileInfoDTO[]

  public static fromReviewedDocumentation (reviewedDocumentation: ReviewedDocumentation): ReviewedDocumentationDTO {
    const fileInfos = reviewedDocumentation.documents().map(current => FileInfoDTO.fromFileInfo(current))
    return new ReviewedDocumentationDTO(
      reviewedDocumentation.procedureCode(),
      reviewedDocumentation.procedureId(),
      reviewedDocumentation.madeiristaId(),
      reviewedDocumentation.batchId(),
      fileInfos
    )
  }

  constructor (
    procedureCode: string,
    procedureInternalId: number,
    madeiristaId: number,
    batchInternalId: number,
    fileInfoDtos: FileInfoDTO[]
  ) {
    this._procedureCode = procedureCode
    this._procedureInternalId = procedureInternalId
    this._madeiristaId = madeiristaId
    this._batchInternalId = batchInternalId
    this._documents = fileInfoDtos
  }

  get procedureCode (): string {
    return this._procedureCode
  }

  get procedureInternalId (): number {
    return this._procedureInternalId
  }

  get madeiristaId (): number {
    return this._madeiristaId
  }

  get batchInternalId (): number {
    return this._batchInternalId
  }

  get documents (): FileInfoDTO[] {
    return this._documents
  }
}
